module.exports = __webpack_public_path__ + "static/media/arrow-right.4f002de7.svg";